<template>
  <b-modal
    :id="modalId"
    ref="modalDelete"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="!p-0"
    dialog-class="modal-dialog-centered !max-w-[420px] !w-full mx-auto"
    content-class="!rounded-[20px] !border-0 overflow-hidden bg-white"
  >
    <div class="bg-white rounded-[20px] py-[28px] px-6 w-full mx-auto flex flex-col items-center">
      <!-- Icon -->
      <div class="flex items-center justify-center mb-5">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="warning"
          width="120px"
          class="w-[120px]"
        >
      </div>

      <!-- Text -->
      <h4 class="text-center font-semibold text-[20px] text-[#0A0A0A] mb-2 mt-0">
        Hapus Konten
      </h4>
      <p
        class="text-center text-[#525252] text-sm leading-[1.5] mb-6 mt-0"
        v-html="subtitleText"
      />

      <!-- Actions -->
      <div class="grid grid-cols-2 gap-[14px] w-full mt-2">
        <button
          type="button"
          class="w-full py-[10px] px-4 rounded-[12px] border border-[#E5E5E5] bg-white text-[#262626] font-medium text-[15px] cursor-pointer transition-colors duration-200 outline-none focus:outline-none hover:bg-[#f8fafc] disabled:opacity-50 disabled:cursor-not-allowed"
          @click="handleClose"
        >
          Batal
        </button>
        <button
          type="button"
          class="w-full py-[10px] px-4 rounded-[12px] bg-[#F95E16] text-white border-0 font-medium text-[15px] cursor-pointer flex items-center justify-center gap-2 transition-colors duration-200 outline-none focus:outline-none hover:bg-[#e04f0d] disabled:opacity-50 disabled:cursor-not-allowed text-nowrap"
          :disabled="isLoading"
          @click="handleDelete"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-2"
          />
          <span v-if="isLoading">Menghapus...</span>
          <span v-else>Hapus Konten</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
    video: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    subtitleText() {
      if (!this.video) return ''

      if (this.video.isBulk) {
        if (this.video.isCheckAll) {
          return '<strong class="font-semibold text-[#0A0A0A]">Semua konten</strong> yang dipilih akan dihapus secara permanen dan tidak dapat dikembalikan. Yakin ingin menghapus konten ini?'
        }
        return `<strong class="font-semibold text-[#0A0A0A]">${this.video.selectedIds ? this.video.selectedIds.length : 0} konten</strong> yang dipilih akan dihapus secara permanen dan tidak dapat dikembalikan. Yakin ingin menghapus konten ini?`
      }
      return '<strong class="font-semibold text-[#0A0A0A]">1 konten</strong> yang dipilih akan dihapus secara permanen dan tidak dapat dikembalikan. Yakin ingin menghapus konten ini?'
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
    async handleDelete() {
      if (!this.video) return

      this.isLoading = true
      try {
        if (this.video.isBulk) {
          await newAxiosIns.delete('/komed/api/v1/komed/content/bulk', {
            data: {
              ids: this.video.selectedIds,
              is_all: this.video.isCheckAll,
            },
          })
        } else {
          if (!this.video.id) return
          await newAxiosIns.delete(`/komed/api/v1/komed/content/${this.video.id}`)
        }
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        this.$toast_error({
          message: error?.response?.data?.message || 'Gagal menghapus konten.',
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
